/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../../../../utils/config';

export const LTE_ENB_IP_URL = `${API_URL}/lteEnbIp`;
